var render = function render(){var _vm=this,_c=_vm._self._c;return _c('model-index',{attrs:{"show_btn_save":false,"show_btn_remove_belongs_to_many":false,"delete_text":_vm.sale_delete_text,"check_permissions":"","not_show_delete_text":"","model_name":"sale"},scopedSlots:_vm._u([{key:"model_modal_header",fn:function(props){return [_c('sale-details')]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }